<div class="content">
  <h2>Set Ship Tag {{ data.targetLabel }}</h2>
  <div class="dialog-body">
    <div class="options-wrapper">
      <div class="option">
        <label>
          <input type="radio" name="strategy" value="field" [(ngModel)]="strategy" />
          Use a single field
        </label>
        @if (strategy === 'field') {
          <select [(ngModel)]="selectedField" name="selectedField">
            @for (field of sourceFields; track field.code) {
              <option [value]="field.code">{{ field.description }}</option>
            }
          </select>
        }
      </div>
      <div class="option">
        <label>
          <input type="radio" name="strategy" value="concat" [(ngModel)]="strategy" />
          Concatenate fields (joined with /)
        </label>
        @if (strategy === 'concat') {
          <div class="concat-fields">
            @for (field of sourceFields; track field.code) {
              <label class="concat-field">
                <input type="checkbox" [(ngModel)]="field.selected" [name]="'concat-' + field.code" />
                {{ field.description }}
              </label>
            }
          </div>
          <div class="disclaimer">
            <span class="disclaimer-entry">Max length for this field is {{ data.maxLength }} characters.</span>
            <span class="disclaimer-entry">Values will be trimmed as needed to meet this requirement.</span>
          </div>
        }
      </div>
      <div class="option">
        <label>
          <input type="radio" name="strategy" value="custom" [(ngModel)]="strategy" />
          Enter my own
        </label>
        @if (strategy === 'custom') {
          <input type="text" [maxlength]="data.maxLength" [(ngModel)]="customValue" name="customValue" />
        }
      </div>
    </div>
    <div class="scope">
      <span class="scope-label">Apply to:</span>
      <label>
        <input type="radio" name="scope" value="all" [(ngModel)]="scope" />
        All units
      </label>
      <label>
        <input type="radio" name="scope" value="blank" [(ngModel)]="scope" />
        Units with blank {{ data.targetLabel }}
      </label>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button class="warn-button" matButton="elevated" (click)="cancel()">Cancel</button>
    <button class="primary-button" matButton="elevated" (click)="apply()">Apply</button>
  </div>
</div>
